import { HomePage } from './../home/home';
import { FrontPage } from '../front/front';
import { AuthProvider } from './../../providers/auth/auth';
import { ServerDetailsNewPage } from './../server-details-new/server-details-new';
import { Component } from '@angular/core';
import { IonicPage, NavController, AlertController,LoadingController, NavParams, Loading } from 'ionic-angular';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  onhomepage = FrontPage;

  serverdetailsnewpage = ServerDetailsNewPage;
  registerCredentials = { username: '', password: '', serverlocation: '', servername: '' };
  loading: Loading;
  private storage: Storage;
// vrsion:string = "2025.082208";

//=============================================
//=============================================
// ACCESS via https://id.insoftapp.com
//=============================================
//=============================================

  constructor(public navCtrl: NavController, storage: Storage, private auth: AuthProvider,
    public navParams: NavParams, private alertCtrl: AlertController, private loadingCtrl: LoadingController) {

    this.storage = storage;
        this.storage.get('ServerName').then((sDetails) => {
            this.registerCredentials.serverlocation = sDetails;
        });
        this.storage.get('ServerName2').then((sDetails) => {
          this.registerCredentials.servername = sDetails;
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');

  }

  public login() {
    this.showLoading()
    // this.auth.login(this.registerCredentials).then((result) => {
    //   //let info = this.auth.getReturnMessage();
    //   //Login success, check if user/login valid
    //   //console.log(result);
    //   if (result['status'] == 200) {
    //     //console.log(result);
    //     this.loading.dismiss();
    //     //this.nav.setRoot(DashboardPage)
    //     this.navCtrl.setRoot(this.onhomepage);
    //   } else {
    //     //console.log('can not login');
    //     this.showError(result['message']);
    //   }

    // }, (err) => {
    //   console.log(err);
    //   this.showError(err['message']);
    // });
        this.auth.login(this.registerCredentials).subscribe(allowed => {
            if (allowed) {
                setTimeout(() => {
                    this.loading.dismiss();
                    this.navCtrl.setRoot(this.onhomepage)
                });
            } else {
                this.showError("Access Denied/Server is not Responding");
            }
        },
            error => {
                this.showError(error);
            });

  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
    });
    this.loading.present();
  }

  showError(text) {
      setTimeout(() => {
          this.loading.dismiss();
      });

      let alert = this.alertCtrl.create({
          title: 'Ooops..',
          subTitle: text,
          buttons: ['OK']
      });
      alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts